import type { AxiosRequestConfig } from 'axios';

export const PAGE_READ_TIMEOUT_MS = 45_000;

// Axios merges defaults before interceptors run. A distinct default preserves
// callers that deliberately specify timeout: 0 (AI/streaming/long operations).
// This marker is always replaced before the request reaches the adapter.
export const INHERIT_READ_TIMEOUT = -1;

export function applyReadRequestDeadline(config: AxiosRequestConfig): void {
  if (config.timeout !== INHERIT_READ_TIMEOUT) return;
  const headers = config.headers || {};
  const method = (config.method || 'get').toLowerCase();
  const readAccept = (value: unknown) =>
    value && typeof value === 'object'
      ? Object.entries(value)
          .filter(([name]) => name.toLowerCase() === 'accept')
          .at(-1)?.[1]
      : undefined;
  const accept = [headers, headers[method], headers.common]
    .map(readAccept)
    .find((value) => value !== undefined);
  const acceptedTypes = String(accept || '').toLowerCase();
  const isJsonRead =
    method === 'get' &&
    (!config.responseType || config.responseType === 'json') &&
    !acceptedTypes.includes('text/event-stream') &&
    (!acceptedTypes ||
      acceptedTypes.includes('json') ||
      acceptedTypes === '*/*');
  config.timeout = isJsonRead ? PAGE_READ_TIMEOUT_MS : 0;
}
